import { Component, ElementRef, ViewChild, OnDestroy, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { OrderService } from 'src/app/services/pedidos/pedidos.service';

@Component({
    selector: 'app-aridos-modal-firma-papel',
    templateUrl: './modal-firma-papel.component.html',
    styleUrls: ['./modal-firma-papel.component.css'],
    standalone: false
})
export class AridosModalFirmaPapelComponent implements OnDestroy {
  @ViewChild('videoElement') videoElement!: ElementRef<HTMLVideoElement>;
  @ViewChild('canvasElement') canvasElement!: ElementRef<HTMLCanvasElement>;

  private stream: MediaStream | null = null;
  photoCaptured: string | null = null;
  loading = false;
  isSuccses= false

  constructor(
    public dialogRef: MatDialogRef<AridosModalFirmaPapelComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private orderService: OrderService
  ) {}

  async ngAfterViewInit() {
    if (this.data?.stream) {
      this.stream = this.data.stream as MediaStream;
      this.attachStream();
      return;
    }
    await this.startCamera();
  }

  private attachStream(retry = 0): void {
    if (!this.stream) return;

    const video = this.videoElement?.nativeElement;
    if (!video) {
      if (retry < 10) {
        setTimeout(() => this.attachStream(retry + 1), 50);
      }
      return;
    }

    video.srcObject = this.stream;
    void video.play().catch(() => undefined);
  }

  async startCamera() {
    this.stream = await this.acquireCameraStream();
    if (!this.stream) {
      alert('No se pudo acceder a la cámara. Verifica los permisos del navegador.');
      return;
    }
    this.attachStream();
  }

  private async acquireCameraStream(): Promise<MediaStream | null> {
    if (!navigator.mediaDevices?.getUserMedia) {
      return null;
    }

    const attempts: MediaStreamConstraints[] = [
      { video: { facingMode: { ideal: 'environment' } }, audio: false },
      { video: { facingMode: 'user' }, audio: false },
      { video: true, audio: false },
    ];

    for (const constraints of attempts) {
      try {
        return await navigator.mediaDevices.getUserMedia(constraints);
      } catch (err) {
        console.warn('Intento de cámara fallido:', err);
      }
    }

    return null;
  }

capturePhoto() {
  const video = this.videoElement.nativeElement;
  const canvas = this.canvasElement.nativeElement;
  const context = canvas.getContext('2d', { willReadFrequently: true }) as CanvasRenderingContext2D;
  if (!context) return;

  // --- 🔹 Paso 1: Reducir resolución ---
  const maxWidth = 300;  // ancho máximo permitido (ajusta según tus necesidades)
  const maxHeight = 200; // alto máximo permitido
  let width = video.videoWidth;
  let height = video.videoHeight;

  // Mantener proporción
  if (width > height) {
    if (width > maxWidth) {
      height = Math.round((height * maxWidth) / width);
      width = maxWidth;
    }
  } else {
    if (height > maxHeight) {
      width = Math.round((width * maxHeight) / height);
      height = maxHeight;
    }
  }

  canvas.width = width;
  canvas.height = height;
  context.drawImage(video, 0, 0, width, height);

  // --- 🔹 Paso 2: Comprimir (calidad entre 0 y 1) ---
  const quality = 0.6; // 0.6 = 60% de calidad → reduce drásticamente el tamaño

  // Convertir a Base64 con compresión JPEG
  this.photoCaptured = canvas.toDataURL('image/jpeg', quality);

  // console.log(
  //   'Tamaño de imagen (aprox):',
  //   (this.photoCaptured.length * 3) / 4 / 1024,
  //   'KB'
  // );

  // --- 🔹 Paso 3: Detener cámara y enviar ---
  this.stopCamera();
  this.saveData();
}


  saveData() {
    if (!this.photoCaptured) return;

    const { tkt, orderNumber, rut, dvrut, name } = this.data;
    const rutCompleto = rut + (dvrut ?? '');

    // console.log(        tkt.toString(),
    //     orderNumber.toString(),
    //     rutCompleto,
    //     name,
    //     this.photoCaptured);

    this.loading = true;
    this.orderService
      .setSignedGuide(
        tkt.toString(),
        orderNumber.toString(),
        rutCompleto,
        name,
        this.photoCaptured,
        ""
      )
      .subscribe({
        next: () => {
          this.loading = false;
          this.isSuccses = true; // enviada o guardada para reintento
        },
        error: (err) => {
          this.loading = false;
          console.error('Error al enviar la firma:', err);
          alert('Ocurrió un error al enviar la firma.');
        }
      });
  }

  stopCamera() {
    if (this.stream) {
      this.stream.getTracks().forEach(track => track.stop());
      this.stream = null;
    }
  }

  onClose() {
    this.stopCamera();
    this.dialogRef.close({ success: this.isSuccses });
  }

  ngOnDestroy() {
    this.stopCamera();
  }
}

